<template>
    <div>
        <movie-header-hero></movie-header-hero>
        <movie-midias></movie-midias>
        <movie-sinopse></movie-sinopse>
        <movie-ficha-tecnica></movie-ficha-tecnica>
        <movie-elenco-dublagem></movie-elenco-dublagem>
    </div>
</template>
<script>
import MovieHeaderHero from "./components/MovieHeaderHero";
import MovieSinopse from "./components/MovieSinopse";
import MovieFichaTecnica from "./components/MovieFichaTecnica";
import MovieMidias from "./components/MovieMidias";
import MovieElencoDublagem from "./components/MovieElencoDublagem";

export default {
  components: {
    MovieHeaderHero,
    MovieSinopse,
    MovieFichaTecnica,
    MovieMidias,
    MovieElencoDublagem
  },
  data() {
    return {
      endpoint: '/v1/titulos/',
      movie_id: this.$route.params.id
    }
  },
  methods: {
    async loadMovieDetail() {
      this.$wait.start('titulo.ficha.load');
      this.axios.get(this.endpoint+this.movie_id+'/')
        .then(response => {
          this.$store.dispatch('catalog/setMovieData', response );
        })
        .catch(e => {
          //console.log(e.message)
        })
        .then(() => {
          this.$wait.end('titulo.ficha.load');
        }); 
      },
  },
  created() {
    this.loadMovieDetail();
  }
};
</script>
<style>
</style>
